import { render, staticRenderFns } from "./OverviewPage.vue?vue&type=template&id=68d3ca8a&scoped=true&"
import script from "./OverviewPage.vue?vue&type=script&lang=ts&"
export * from "./OverviewPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d3ca8a",
  null
  
)

export default component.exports